<template>
    <div class="card-team">
        <div>
            <img :src="`/storage/${worker.image}`" :alt="worker.name" />
            <div class="bg-image-dark"></div>
            <div v-if="worker.type == 'teacher'" class="circle">
                <img src="/img/icons/add_circle_orange.svg" />
            </div>
        </div>
        <div class="card-team-name">
            <h6>{{worker.name}}</h6>
            <p v-if="worker.type == 'team'" class="pb-6">{{worker.job[locale]}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['worker'],
    data() {
        return {
            locale: window.appLocale
        }
    },
};
</script>

<style lang="scss" scoped>
.card-team {
    width: 100%;
    max-width: 160px;
    position: relative;
    @media (min-width: 1024px) {
        width: 224px;
        max-width: 100%;
    }
    &:hover {
        .bg-image-dark {
            opacity: 0;
        }
        .card-team-name {
            background-color: #00559a;
        }
        .circle {
            opacity: 1;
        }
    }
    .circle {
        position: absolute;
        top: 55px;
        left: 55px;
        opacity: 0;
        @media (min-width: 1024px) {
            top: 80px;
            left: 85px;
        }
        img {
            width: 50px;
            height: 50px;
        }
    }
    .bg-image-dark {
        background-color: rgba($color: #000000, $alpha: 0.3);
        z-index: 2;
        top: 0;
        left: 0;
        position: absolute;
        transition: 0.3s;
        width: 100%;
        max-width: 160px;
        height: 151px;
        @media (min-width: 1024px) {
            max-width: 100%;
            width: 224px;
            height: 210px;
        }
    }
    img {
        width: 100%;
        height: auto;
        @media (min-width: 1024px) {
            width: 100%;
            height: 210px;
        }
        object-fit: cover;
    }
    &-name {
        background-color: #0f304d;
        color: white;
        text-align: center;
        transition: 0.3s;
        min-height: 130px;
        h6 {
            padding: 1rem 0.5rem;
        }
    }
}
</style>
